export const contacts = {
  phone: '+966506728299',
  whatsAppLink: 'https://wa.me/+966506728299',
};
